
var TestCtrl = function ($scope, $timeout) {

    var _this = this;

    $scope.formModel = {
        requiredField1: "test?",
        requiredField2: "test?"
        // you may also initialize your checkboxes in the controller
        /*,
        check1:true,
        check2:false
        */
    };

    // the following is much easier with the template
    /*function yourCondition(){
        return $scope.formModel.check1 || $scope.formModel.check2;
    }
    // first initialization - requires timeout to ng-init kick off
    $timeout(function(){
        _this.result = yourCondition();
    });
    // condition watcher
    $scope.$watch( yourCondition, function(newVal, oldVal){
        if( newVal != oldVal ){
            _this.result = newVal;
        }
    });*/

}
TestCtrl.$inject = ['$scope', '$timeout'];
angular.module('app').controller('TestCtrl',TestCtrl);


var TestNotificationCtrl = function ($scope, $timeout, xmsNotificationFactory) {
    $timeout(function(){
        xmsNotificationFactory.addObj( {id: 'newNotif', type: 'info',
            bodyHtml: '<strong>Now you can dynamically add the notifications!</strong><br/>See Other Components > Notifications for more details.'});
    },10000);
}
TestNotificationCtrl.$inject = ['$scope', '$timeout', 'xmsNotificationFactory'];
angular.module('app').controller('TestNotificationCtrl', TestNotificationCtrl);